/**
 * Reactive variable store — replaces Apollo Client's makeVar.
 * Each exported function acts as both getter (no args) and setter (with arg),
 * maintaining the same call-site API: `accessToken()` to read, `accessToken('value')` to write.
 */

type ReactiveVar<T> = {
  (): T;
  (newValue: T): T;
};

function makeReactiveVar<T>(initialValue: T): ReactiveVar<T> {
  let value: T = initialValue;
  return function reactiveVar(...args: [T] | []) {
    if (args.length > 0) {
      value = args[0] as T;
    }
    return value;
  } as ReactiveVar<T>;
}

export const accessToken = makeReactiveVar('');
export const monthlyPayment = makeReactiveVar(0);
export const dateOfBirth = makeReactiveVar('');
export const portalApplicationId = makeReactiveVar(0);
export const cacChubSSNId = makeReactiveVar('');
